import http from '@/utils/http'

export function upgradeWill(id,data){
  return  http.post(`/subscriptions/${id}/upgrade_will_request`,data)
}
export function upgradeRequest(id){
    return  http.post(`/subscriptions/${id}/upgrade_request`)
}